import { Plus, X } from "lucide-react";

export const SpecsEditor = ({ specs, onChange }) => {
  const update = (i, key, val) => onChange(specs.map((s, idx) => (idx === i ? { ...s, [key]: val } : s)));
  const cls = "h-10 min-w-0 flex-1 rounded-lg border border-[#E5E0D8] bg-white px-3 text-sm outline-none focus:border-[#C59B27]";
  return (
    <div className="space-y-2" data-testid="specs-editor">
      {specs.map((s, i) => (
        <div key={i} className="flex gap-2">
          <input value={s.k} onChange={(e) => update(i, "k", e.target.value)} placeholder="e.g. Finish" className={cls} data-testid={`spec-key-${i}`} />
          <input value={s.v} onChange={(e) => update(i, "v", e.target.value)} placeholder="e.g. Hammered" className={cls} data-testid={`spec-value-${i}`} />
          <button type="button" onClick={() => onChange(specs.filter((_, idx) => idx !== i))} className="grid h-10 w-10 shrink-0 place-items-center rounded-lg hover:bg-[#F6E4E1]" aria-label="Remove" data-testid={`spec-remove-${i}`}><X className="h-4 w-4" /></button>
        </div>
      ))}
      <button type="button" onClick={() => onChange([...specs, { k: "", v: "" }])} className="inline-flex items-center gap-1 text-sm font-semibold text-[#1B4332]" data-testid="spec-add-btn"><Plus className="h-4 w-4" /> Add specification</button>
    </div>
  );
};
